import { styled } from '@linaria/react';
import { primitives, semantic, size, space } from '../../theme/tokens';

export const Track = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-100']};
  width: 100px;
`;

export const Segment = styled.span`
  flex: 1;
  height: ${primitives.size['size-100']};
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.surfaceSubtle};

  &[data-active='true'] {
    background: ${semantic.bg.positiveStrong};
  }
`;
